module.exports = __webpack_public_path__ + "assets/game-type-assessment.35ecc8e4.svg";